/**
 * RadioGroup — 라디오 버튼 그룹
 */

import { cn } from '../../lib/cn.js'
import styles from './RadioGroup.module.css'

export interface RadioOption {
  value: string
  label: string
}

export interface RadioGroupProps {
  value: string
  onChange: (value: string) => void
  options: RadioOption[]
  name?: string
  disabled?: boolean
  className?: string
}

export function RadioGroup({
  value,
  onChange,
  options,
  name,
  disabled = false,
  className,
}: RadioGroupProps) {
  return (
    <div className={cn(styles.group, disabled && styles.disabled, className)}>
      {options.map((opt) => (
        <label key={opt.value} className={styles.wrapper}>
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => !disabled && onChange(opt.value)}
            disabled={disabled}
            className={styles.input}
          />
          <span className={styles.label}>{opt.label}</span>
        </label>
      ))}
    </div>
  )
}
